/** Deep-merge two plain-object trees, child wins. Arrays are replaced, not
 *  concatenated, because the JSON-author's intent is "this is the new array,
 *  not extend the parent's". */
export function deepMerge(parent, child) {
    if (!isPlainObject(parent) || !isPlainObject(child)) {
        return (child === undefined ? parent : child);
    }
    const out = {};
    const p = parent;
    const c = child;
    for (const k of Object.keys(p))
        out[k] = p[k];
    for (const k of Object.keys(c)) {
        const pv = out[k];
        const cv = c[k];
        if (isPlainObject(pv) && isPlainObject(cv)) {
            out[k] = deepMerge(pv, cv);
        }
        else if (cv !== undefined) {
            out[k] = cv;
        }
    }
    return out;
}
function isPlainObject(v) {
    if (v === null || typeof v !== "object")
        return false;
    return Object.getPrototypeOf(v) === Object.prototype;
}
